export function getBirdviewBarsChartMaxValue(items) {
  return Math.max(...items.map(item => item.value))
}

export function checkIsBirdviewBarsChartRowActive({ activeId, item }) {
  return activeId === item.id
}

export function checkIsBirdviewBarsChartFirstRow(index) {
  return index === 0
}
